<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('profile.material.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('profile.material.public') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.public"
                :error-messages="publicErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-textarea
            v-model="item.description"
            :error-messages="descriptionErrors"
            :label="$t('profile.material.description')"
            @input="$v.item.description.$touch()"
            @blur="$v.item.description.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-textarea
            v-model="item.comment"
            :error-messages="commentErrors"
            :label="$t('profile.material.comment')"
            @input="$v.item.comment.$touch()"
            @blur="$v.item.comment.$touch()"
          />
        </v-col>
      </v-row>

      <v-row class="ml-5 mt-5">
        <h2><v-icon class="mr-2">mdi-pencil-ruler</v-icon>{{$t('profile.material.measures')}}</h2>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.tempResistance"
            :error-messages="tempResistanceErrors"
            :label="$t('profile.material.tempresistance')"
            required
            @input="$v.item.tempResistance.$touch()"
            @blur="$v.item.tempResistance.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.chemicalResistance"
            :error-messages="chemicalResistanceErrors"
            :label="$t('profile.material.chemicalresistance')"
            required
            @input="$v.item.chemicalResistance.$touch()"
            @blur="$v.item.chemicalResistance.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.uvResistance"
            :error-messages="uvResistanceErrors"
            :label="$t('profile.material.uvresistance')"
            required
            @input="$v.item.uvResistance.$touch()"
            @blur="$v.item.uvResistance.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.mecaResistance"
            :error-messages="mecaResistanceErrors"
            :label="$t('profile.material.mecaresistance')"
            required
            @input="$v.item.mecaResistance.$touch()"
            @blur="$v.item.mecaResistance.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.abrasionResistance"
            :error-messages="abrasionResistanceErrors"
            :label="$t('profile.material.abrasionresistance')"
            required
            @input="$v.item.abrasionResistance.$touch()"
            @blur="$v.item.abrasionResistance.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.tractionResistance"
            :error-messages="tractionResistanceErrors"
            :label="$t('profile.material.tractionresistance')"
            required
            @input="$v.item.tractionResistance.$touch()"
            @blur="$v.item.tractionResistance.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.complexity"
            :error-messages="complexityErrors"
            :label="$t('profile.material.complexity')"
            required
            @input="$v.item.complexity.$touch()"
            @blur="$v.item.complexity.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.density"
            :error-messages="densityErrors"
            :label="$t('profile.material.density')"
            required
            @input="$v.item.density.$touch()"
            @blur="$v.item.density.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.elongation"
            :error-messages="elongationErrors"
            :label="$t('profile.material.elongation')"
            required
            @input="$v.item.elongation.$touch()"
            @blur="$v.item.elongation.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.tenacity"
            :error-messages="tenacityErrors"
            :label="$t('profile.material.tenacity')"
            required
            @input="$v.item.tenacity.$touch()"
            @blur="$v.item.tenacity.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.cost"
            :error-messages="costErrors"
            :label="$t('profile.material.cost')"
            required
            @input="$v.item.cost.$touch()"
            @blur="$v.item.cost.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.electrical"
            :error-messages="electricalErrors"
            :label="$t('profile.material.electrical')"
            required
            @input="$v.item.electrical.$touch()"
            @blur="$v.item.electrical.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.thermal"
            :error-messages="thermalErrors"
            :label="$t('profile.material.thermal')"
            required
            @input="$v.item.thermal.$touch()"
            @blur="$v.item.thermal.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.dielectric"
            :error-messages="dielectricErrors"
            :label="$t('profile.material.dielectric')"
            required
            @input="$v.item.dielectric.$touch()"
            @blur="$v.item.dielectric.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.tempFusion"
            :error-messages="tempFusionErrors"
            :label="$t('profile.material.tempfusion')"
            required
            @input="$v.item.tempFusion.$touch()"
            @blur="$v.item.tempFusion.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="hardnessShoreTypeSelectItems"
            v-model="item.hardnessShoreType"
            :items="hardnessShoreTypeSelectItems"
            :no-data-text="$t('global.no_result')"
  :placeholder="$t('global.no_select')"
  clearable
            :label="$t('profile.material.hardnessshoretype')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.hardnessShore"
            :error-messages="hardnessShoreErrors"
            :label="$t('profile.material.hardnessshore')"
            required
            @input="$v.item.hardnessShore.$touch()"
            @blur="$v.item.hardnessShore.$touch()"
          />
        </v-col>
      </v-row>

    </v-container>
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'MaterialTypeForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
          this.hardnessShoreTypeGetSelectItems();
  },
  data() {
    return {
        name: null,
        comment: null,
        description: null,
        tempResistance: null,
        chemicalResistance: null,
        uvResistance: null,
        mecaResistance: null,
        abrasionResistance: null,
        tractionResistance: null,
        complexity: null,

        elongation: null,
        tenacity: null,
        cost: null,
        density: null,
        electrical: null,
        thermal: null,
        dielectric: null,
        public: null,
        hardnessShore: null,
        hardnessShoreType: null,
        tempFusion: null,
    };
  },
  computed: {
    ...mapFields('hardnessshoretype', {
      hardnessShoreTypeSelectItems: 'selectItems',
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    commentErrors() {
      const errors = [];
      if (!this.$v.item.comment.$dirty) return errors;
      has(this.violations, 'comment') && errors.push(this.violations.comment);
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.item.description.$dirty) return errors;
      has(this.violations, 'description') && errors.push(this.violations.description);
      return errors;
    },
    publicErrors() {
      const errors = [];
      if (!this.$v.item.public.$dirty) return errors;
      has(this.violations, 'public') && errors.push(this.violations.public);
      return errors;
    },
    tempResistanceErrors() {
      const errors = [];
      if (!this.$v.item.tempResistance.$dirty) return errors;
      has(this.violations, 'tempResistance') && errors.push(this.violations.tempResistance);
      return errors;
    },
    chemicalResistanceErrors() {
      const errors = [];
      if (!this.$v.item.chemicalResistance.$dirty) return errors;
      has(this.violations, 'chemicalResistance') && errors.push(this.violations.chemicalResistance);
      return errors;
    },
    uvResistanceErrors() {
      const errors = [];
      if (!this.$v.item.uvResistance.$dirty) return errors;
      has(this.violations, 'uvResistance') && errors.push(this.violations.uvResistance);
      return errors;
    },
    mecaResistanceErrors() {
      const errors = [];
      if (!this.$v.item.mecaResistance.$dirty) return errors;
      has(this.violations, 'mecaResistance') && errors.push(this.violations.mecaResistance);
      return errors;
    },
    abrasionResistanceErrors() {
      const errors = [];
      if (!this.$v.item.abrasionResistance.$dirty) return errors;
      has(this.violations, 'abrasionResistance') && errors.push(this.violations.abrasionResistance);
      return errors;
    },
    tractionResistanceErrors() {
      const errors = [];
      if (!this.$v.item.tractionResistance.$dirty) return errors;
      has(this.violations, 'tractionResistance') && errors.push(this.violations.tractionResistance);
      return errors;
    },
    complexityErrors() {
      const errors = [];
      if (!this.$v.item.complexity.$dirty) return errors;
      has(this.violations, 'complexity') && errors.push(this.violations.complexity);
      return errors;
    },
    hardnessShoreErrors() {
      const errors = [];
      if (!this.$v.item.hardnessShore.$dirty) return errors;
      has(this.violations, 'hardnessShore') && errors.push(this.violations.hardnessShore);
      return errors;
    },
    hardnessShoreTypeErrors() {
      const errors = [];
      if (!this.$v.item.hardnessShoreType.$dirty) return errors;
      has(this.violations, 'hardnessShoreType') && errors.push(this.violations.hardnessShoreType);
      return errors;
    },
    elongationErrors() {
      const errors = [];
      if (!this.$v.item.elongation.$dirty) return errors;
      has(this.violations, 'elongation') && errors.push(this.violations.elongation);
      return errors;
    },
    tenacityErrors() {
      const errors = [];
      if (!this.$v.item.tenacity.$dirty) return errors;
      has(this.violations, 'tenacity') && errors.push(this.violations.tenacity);
      return errors;
    },
    costErrors() {
      const errors = [];
      if (!this.$v.item.cost.$dirty) return errors;
      has(this.violations, 'cost') && errors.push(this.violations.cost);
      return errors;
    },
    densityErrors() {
      const errors = [];
      if (!this.$v.item.density.$dirty) return errors;
      has(this.violations, 'density') && errors.push(this.violations.density);
      return errors;
    },
    electricalErrors() {
      const errors = [];
      if (!this.$v.item.electrical.$dirty) return errors;
      has(this.violations, 'electrical') && errors.push(this.violations.electrical);
      return errors;
    },
    thermalErrors() {
      const errors = [];
      if (!this.$v.item.thermal.$dirty) return errors;
      has(this.violations, 'thermal') && errors.push(this.violations.thermal);
      return errors;
    },
    dielectricErrors() {
      const errors = [];
      if (!this.$v.item.dielectric.$dirty) return errors;
      has(this.violations, 'dielectric') && errors.push(this.violations.dielectric);
      return errors;
    },
    tempFusionErrors() {
      const errors = [];
      if (!this.$v.item.tempFusion.$dirty) return errors;
      has(this.violations, 'tempFusion') && errors.push(this.violations.tempFusion);
      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
    ...mapActions({

      hardnessShoreTypeGetSelectItems: 'hardnessshoretype/fetchSelectItems'
    }),
  },
  validations: {
    item: {
      name: {
        required,
      },
      comment: {},
      description: {},
      tempResistance: {},
      chemicalResistance: {},
      uvResistance: {},
      mecaResistance: {},
      abrasionResistance: {},
      tractionResistance: {},
      complexity: {},

      elongation: {},
      tenacity: {},
      cost: {},
      density: {},
      electrical: {},
      thermal: {},
      dielectric: {},
      public: {},
      hardnessShore: {},
      hardnessShoreType: {},
      tempFusion: {},
    }
  }
};
</script>
